import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ListTableComponent } from "../../../../shared/components/list-table/list-table.component";
import { TimesheetService } from '../../../../services/timesheet.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-auth-timesheets',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './auth-timesheets.component.html',
  styleUrl: './auth-timesheets.component.css'
})
export class AuthTimesheetsComponent implements OnInit, OnChanges {
  mode = 'read';
  programName!: string;
  columnsToBeHidden: string[] = [];
  sharedDataKey!: string;
  actionsToBeHidden: string[] = [];
  lazyLoad = true;
  isPageRestrictionLoaded = false;
  @Input() authData: any;
  authTSUtilizationData: any;

  constructor(
    private timesheetService: TimesheetService,
    private userService: UserService
  ) {}

  ngOnInit() {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.isPageRestrictionLoaded = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['authData'] && changes['authData'].currentValue) {
      this.getUtilizationData();
    }
  }

  getUtilizationData() {
    this.timesheetService
      .getAuthTimesheetUtilization(
        this.programName,
        this.authData?.authorizationId,
        this.authData?.participantId
      )
      .subscribe((data: any) => {
        this.authTSUtilizationData = data.responsedata?.map((item: any) => {
          if (item.serviceFromDate) {
            item.serviceFromDate = this.formatDateToUSDateString(item.serviceFromDate)
          }
          if (item.serviceToDate) {
            item.serviceToDate = this.formatDateToUSDateString(item.serviceToDate)
          }
          return item;
        });
      });
  }

  rowClicked(event: unknown) {}

  formatDateToUSDateString(dateString: string): string {
    const [year, month, day] = dateString.split('-');
    return `${month}/${day}/${year}`;
}
}
